import { NetworkStatus } from '@apollo/client';
import { getLastErrorMessage } from './getLastErrorMessage';
import { VendorDataContractErrorList } from '../store/models/Project';

export const getNetworkStatusMessage = (
  networkStatus: NetworkStatus,
  isLoading: boolean,
  count: number,
  errorMessages: VendorDataContractErrorList[] | null,
) => {
  if (networkStatus === NetworkStatus.refetch) {
    return 'Refetching...';
  }
  if (networkStatus === NetworkStatus.loading) {
    return 'Loading...';
  }
  if (!isLoading) {
    if (errorMessages) {
      return `ERROR: ${getLastErrorMessage(errorMessages) || ''}`;
    }
    return count || 'No errors found';
  }
  return '';
};
